import React from "react";

import Page from "../components/Page";
import CenteredPageContentContainer from "../components/CenteredPageContentContainer";
import PaperContainer from "../components/PaperContainer";
import HourRegistration from "../components/HourRegistration";

const HourRegistrationPage = () => (
  <Page title="Urenregistratie">
    <CenteredPageContentContainer>
      <PaperContainer title="Urenregistratie">
        <HourRegistration />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

export default HourRegistrationPage;



// WEBPACK FOOTER //
// ./src/pages/HourRegistrationPage.js